import type { FontStyle, FontWeight, Fonts } from '@pff-consumer/core-ui'
import { FontWeights, PRIMARY_FONT, SECONDARY_FONT } from '@pff-consumer/core-ui'
import { Platform } from 'react-native'

export interface FontAttributes {
  weight: FontWeight
  style: FontStyle
}

export interface Font extends FontAttributes {
  name: string
}

export const fonts = new Map<string, Font[]>([
  [
    PRIMARY_FONT,
    [
      { name: 'Archivo-Black', weight: FontWeights.BLACK, style: 'normal' },
      { name: 'Archivo-BlackItalic', weight: FontWeights.BLACK, style: 'italic' },
      { name: 'Archivo-ExtraBold', weight: FontWeights.XBOLD, style: 'normal' },
      { name: 'Archivo-ExtraBoldItalic', weight: FontWeights.XBOLD, style: 'italic' },
      { name: 'Archivo-Bold', weight: FontWeights.BOLD, style: 'normal' },
      { name: 'Archivo-BoldItalic', weight: FontWeights.BOLD, style: 'italic' },
      { name: 'Archivo-SemiBold', weight: FontWeights.SEMIBOLD, style: 'normal' },
      { name: 'Archivo-SemiBoldItalic', weight: FontWeights.SEMIBOLD, style: 'italic' },
      { name: 'Archivo-Regular', weight: FontWeights.REGULAR, style: 'normal' },
      { name: 'Archivo-Italic', weight: FontWeights.REGULAR, style: 'italic' },
    ],
  ],
  [
    SECONDARY_FONT,
    [
      { name: 'ArchivoNarrow-Regular', weight: FontWeights.REGULAR, style: 'normal' },
      { name: 'ArchivoNarrow-SemiBold', weight: FontWeights.SEMIBOLD, style: 'normal' },
      { name: 'ArchivoNarrow-Bold', weight: FontWeights.BOLD, style: 'normal' },
    ],
  ],
])

export const getFontStyles = (family: Fonts, weight: FontWeight = FontWeights.REGULAR, style: FontStyle = 'normal') => {
  const foundFont = fonts.get(family)?.filter((f) => f.style === style && f.weight === weight)[0]
  return Platform.select({
    android: { fontFamily: foundFont?.name },
    ios: {
      fontFamily: family,
      fontWeight: foundFont?.weight,
      fontStyle: foundFont?.style,
    },
    web: {
      fontFamily: family,
      fontWeight: foundFont?.weight,
      fontStyle: foundFont?.style,
    },
  })
}
